import { TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { IoMdTrash } from "react-icons/io";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CustomDropdown, { DropdownSelectOnly, DropdownWithCustomInput } from "../CustomDropdown/CustomDropdown";
import { CustomCheckbox } from "../customCheckbox/customCheckBox";
import { useSharedCrm } from "../../itemPage/sharedCrmContext";
import './sharedCrm.css';
import { useLocation } from "react-router-dom";
const DynamicForm = ({
    labels = [],
    formData = {},
    // showAddress,
    handletextField,
    handleFieldSelect,
    onSubmit,
    disabled,
    customer,
    handleOpenRadioModal,
    setFormData,
    // useInputField = false,
  }) => {
    const location = useLocation();
    const { additionalData } = location.state || {};
    const [openDropdownField, setOpenDropdownField] = useState(null);
    const dropdownRef = useRef(null);
    const [searchValues, setSearchValues] = useState({});
    const {formDataError,setFormDataError,showAddress } = useSharedCrm();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownField(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  // const handleInputChange = (e) => {
  //   const input = e.target.value;
  //   setSearchValue(input);
  //   setOpenDropdownField(true);

  //   if (!field.allowCustomInput) {
  //     const matched = field.options.find((item) => {
  //       const display = field.getDisplayValue
  //         ? field.getDisplayValue(item)
  //         : item?.label || "";
  //       return display.toLowerCase() === input.toLowerCase();
  //     });

  //     if (!matched) {
  //       setFormErrors((prev) => ({
  //         ...prev,
  //         [field.field]: field.message || "Please select a valid option",
  //       }));
  //     } else {
  //       setFormErrors((prev) => ({ ...prev, [field.field]: "" }));
  //     }
  //   } else {
  //     setFormErrors((prev) => ({ ...prev, [field.field]: "" }));
  //   }
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   let errors = {};
  //   labels.forEach(({ field, required, label }) => {
  //     if (required && !formData[field]) {
  //       errors[field] = `${label} is required`;
  //     }
  //   });
  //   if (Object.keys(errors).length > 0) {
  //     // setFormErrors(errors);
  //     return;
  //   }
  //   if (onSubmit) {
  //     onSubmit(formData);
  //   }
  // };
  const getDisplayValueForField = (fieldName, data) => {
    if (fieldName === "Segment" && Array.isArray(data)) {
      return data.map(item => item.u_Segment).join(", ");
    }
    if (fieldName === "ItemsChecked" && Array.isArray(data)) {
      return data.map(item => item.itemName).join(", ");
    }
    return data ?? "";
  };
  
    return (
      <form className="" 
      // onSubmit={handleSubmit}
      >
        {/* <div className="row g-3"> */}
          {labels.map((field, i) => {
            // const fieldValue = !useInputField ? formData[field.label] : formData[field.field];
            // const HandlefieldValue = !useInputField ? field.label : field;
            let inputElement;
            let errorMessage = formDataError[field.field] || "";
            // if (field.isMulti && field.type === "text") {
            //   const values = Array.isArray(fieldValue) ? fieldValue : [];
            //   inputElement = (
            //     <>
            //       {values.map((val, idx) => (
            //         <div
            //           key={idx}
            //           style={{
            //             display: "flex",
            //             alignItems: "center",
            //             marginBottom: "8px",
            //           }}
            //         >
            //           <input
            //             type="text"
            //          className="customer-textfield"
            //             placeholder={`${field.label} ${idx + 1}`}
            //             value={fieldValue}
            //             onChange={(e) => {
            //               const updated = [...values];
            //               updated[idx] = e.target.value;
            //               onChange(HandlefieldValue, updated);
            //             }}
            //             disabled={disabled}
            //             autoComplete="off"
            //           />
            //           {!disabled && idx > 0 && (
            //             <button
            //               type="button"
            //               onClick={() => {
            //                 const updated = [...values];
            //                 updated.splice(idx, 1);
            //                 onChange(HandlefieldValue, updated);
            //               }}
            //               style={{
            //                 marginLeft: "5px",
            //                 background: "none",
            //                 border: "none",
            //                 cursor: "pointer",
            //               }}
            //               title="Remove"
            //             >
            //               <IoMdTrash color="#dc3545" />
            //             </button>
            //           )}
            //         </div>
            //       ))}
            //       {!disabled && (
            //         <button
            //           className="Add-Achievements"
            //           type="button"
            //           onClick={() => {
            //             const updated = [...values, ""];
            //             // onChange(field.label, updated);
            //             onChange(HandlefieldValue, updated);
            //           }}
            //         >
            //           + Add {field.label}
            //         </button>
            //       )}
            //     </>
            //   );
            // }

            if (field.type === "text") {
              inputElement = (
             <div className="customer-creation-textfield">
            <TextField
              id="Reference"
              label={field.label}
              name={field.field} 
              variant="standard"
              required
              onChange={handletextField}
              // error={!!formDataError[field.field]}
              // helperText={formDataError[field.field]}
              className="customer-textfield"
              value={formData[field.field]}
              autoComplete="off"
            />
              {errorMessage && <div className="error-message">{errorMessage}</div>} {/* Show error if exists */}
         </div>
              )
            }
            // Select field (single or multi)
            // if (field.type === "customDropdown") {
            //   return (
            //     <div key={field.field} >      
            // {field.allowCustomInput ? (
            //   <DropdownWithCustomInput
            //     field={field}
            //     formData={formData}
            //     onChange={handleChange}
            //     disabled={disabled}
            //   />
            // ) : (
            //   {additionalData!=="sqUpdate"}
            //   <DropdownSelectOnly
            //     field={field}
            //     formData={formData}
            //     onChange={handleChange}
            //     disabled={disabled}
            //   />
            // )}
            if (field.type === "customDropdown") {
              return (
                <div key={field.field}>
                  {field.allowCustomInput ? (
                    <DropdownWithCustomInput
                      field={field}
                      formData={formData}
                      onChange={handleChange}
                      disabled={disabled}
                    />
                  ) : (
                    !["OpporItemPage", "sqUpdate"].includes(additionalData) && (
                      <DropdownSelectOnly
                        field={field}
                        formData={formData}
                        onChange={handleChange}
                        disabled={disabled}
                      />
                    )
                  )}
                </div>
              );
            }
            
         
            else if (field.type === "RadioButton") {
              const displayValue = getDisplayValueForField(field.field, formData[field.field]);
              inputElement = (
                <div ref={dropdownRef} className="customer-creation-textfield Customer-ErrorDiv">
                <TextField
                   variant="standard"
                  label={field.label}
                  value={displayValue}
                  // onChange={handleFieldChange}
                  disabled={field.field==="AssignExecutive"}
                  onClick={() => handleOpenRadioModal(field.field)}
                  required={field.required}
                  className="customer-textfield"
                />
                {errorMessage && <div className="error-message">{errorMessage}</div>}
                </div>
              );
            }
            else if(field.type==="dateField"){
              inputElement=(
                <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Completion Of Work"
                name="ExpectedComplationOfWork"
                className="customer-datefield "
                value={formData[field.field] ? dayjs(formData[field.field]) : null}
                // onClick={() => handleOpenRadioModal(field.field)}
                onChange={(newValue) =>
                  handleFieldSelect('ExpectedComplationOfWork', dayjs(newValue).format("YYYY-MM-DD"))
                }

                minDate={dayjs()}
                format="DD/MM/YYYY"
              />
                {errorMessage && <div className="error-message">{errorMessage}</div>}
            </LocalizationProvider>
              )
            }
            else if (field.type === "Checkbox") {
              inputElement = (
                <>
                  <label htmlFor={`input-${i}`}>{field.label}</label>
                  <div className="d-flex flex-row">
                    {["YES", "NO"].map((value) => (
                      <div key={value} className="sitevistDiv">
                        <CustomCheckbox
                          checked={formData[field.field] === value}  // This checks if the current value is 'YES' or 'NO'
                          onChange={handletextField}                  // Handles the change when a checkbox is clicked
                          value={value}                               // The value of the checkbox ('YES' or 'NO')
                          name={field.field}                          // Ensure the name matches the field you're working with
                          id={`input-${i}-${value}`}                  // Unique ID for each checkbox
                        />
                        <label 
                          className="siteVistLabel" 
                          htmlFor={`input-${i}-${value}`}            // Links label to the checkbox using `htmlFor`
                        >
                          {value}
                        </label>
                      </div>
                    ))}
                  </div>
                  {errorMessage && <div className="error-message">{errorMessage}</div>}
                </>
              );
            }
            
            else if (field.type === "textarea" ) {
              inputElement = (
                <>
               {showAddress && (
  <>
    <label htmlFor={`input-${i}`}>{field.label}</label>
    <textarea
      id={`input-${i}`}
      name={field.field}  // This should match the field name in formData
      className="textarea-input"
      placeholder={`Enter ${field.label}`}
      onChange={handletextField}  // This will handle the change event
      value={formData[field.field] || ""}  // Ensure a fallback if the field is undefined
      rows={3}  // Adjust the rows as needed
    />
      {errorMessage && <div className="error-message">{errorMessage}</div>}
  </>
)}

                </>
              );
            }
            // Regular input field
            // else {
            //   inputElement = (
            //     <input
            //       type={field.type || "text"}
            //       id={`input-${i}`}
            //       className="minimal-input"
            //       placeholder={`Enter ${field.label}`}
            //       value={fieldValue || ""}
            //       onChange={(e) => onChange(HandlefieldValue, e.target.value)}
            //       disabled={disabled}
            //       autoComplete="off"
            //     />
            //   );
            // }
            // const fieldv = !useInputField ? field.label : field.field
            return (
              <div
                key={i}
                className={`customer-creation`}
              >
                {inputElement}
              </div>
            );
          })}
        
      </form>

    );
  };
  



  export default DynamicForm;

  // const isOpen = openDropdownField === field.field;
  // const searchValue = searchValues[field.field] ?? (fieldValue || "");
  // console.log("searchValue :", searchValue ,"fieldValue :", fieldValue, "formData :", formData );
  
  // const setSearchValue = (value) => {
  //   setSearchValues((prev) => ({ ...prev, [field.field]: value }));
  // };
  // const searchValStr = String(searchValue || "").toLowerCase();
  // const filteredOptions = Array.isArray(field.options)
  //   ? field.options.filter((item) => {
  // const display = field.getDisplayValue
  //   ? field.getDisplayValue(item)
  //   : item?.label || "";
  // return String(display).toLowerCase().includes(searchValStr);
  // })
  // : [];

  // const handleSelectOption = (item) => {
  //   console.log("item :", item, field.field);

  //   const displayValue = field.getDisplayValue
  //     ? field.getDisplayValue(item)
  //     : item?.label || "";
  //   console.log("displayValue :", displayValue);
    
  //   setSearchValue(displayValue);
  //   onChange(field.field, item);
  //   setFormErrors((prev) => ({ ...prev, [field.field]: "" }));
  //   setOpenDropdownField(null);
  // };

  // const handleInputChange = (e) => {
  //   const input = e.target.value;
  //   setSearchValue(input);
  // //   onChange(field.field, input);
  //   setOpenDropdownField(field.field);

  //   // Validation: only allow selection from list if allowCustomInput is false
  //   if (!field.allowCustomInput) {
  //     const matched = field.options.find((item) => {
  //       const display = field.getDisplayValue
  //         ? field.getDisplayValue(item)
  //         : item?.label || "";
  //       return display.toLowerCase() === input.toLowerCase();
  //     });

  //     if (!matched) {
  //       setFormErrors((prev) => ({
  //         ...prev,
  //         [field.field]: field.message || "Please select a valid option",
  //       }));
  //     } else {
  //       setFormErrors((prev) => ({ ...prev, [field.field]: "" }));
  //     }
  //   } else {
  //     setFormErrors((prev) => ({ ...prev, [field.field]: "" }));
  //   }
  // };

  // const handleBlur = () => {
  //   // Same logic to enforce match on blur
  //   if (!field.allowCustomInput) {
  //     const matched = field.options.find((item) => {
  //       const display = field.getDisplayValue
  //         ? field.getDisplayValue(item)
  //         : item?.label || "";
  //       return display.toLowerCase() === searchValue.toLowerCase();
  //     });

  //     if (!matched) {
  //       setFormErrors((prev) => ({
  //         ...prev,
  //         [field.field]: field.message || "Please select a valid option",
  //       }));
  //     }
  //   }
  // };

  // inputElement = (
  //   <div className="customer-creation-textfield Customer-ErrorDiv" ref={dropdownRef}>
  //     <TextField
  //       variant="standard"
  //       label={field.label}
  //       required={field.required}
  //       value={searchValue}
  //       onClick={() => setOpenDropdownField(isOpen ? null : field.field)}
  //       onChange={handleInputChange}
  //       // onBlur={handleBlur}
  //       autoComplete="off"
  //       className="customer-textfield"
  //       error={!!formErrors[field.field]}
  //       helperText={formErrors[field.field] || ""}
  //       disabled={disabled}
  //     />

  //     {isOpen && (
  //       <ul className="custom-dropdown">
  //         {filteredOptions.length > 0 ? (
  //           filteredOptions.map((item, index) => (
  //             <li
  //               key={index}
  //               // onClick={() => handleSelectOption(item)}
  //               onMouseDown={() => handleSelectOption(item)} 
  //               className="dropdown-item"
  //             >
  //               {field.getDisplayValue
  //                 ? field.getDisplayValue(item)
  //                 : item?.label}
  //             </li>
  //           ))
  //         ) : (
  //           <li className="dropdown-item disabled">
  //             {field.message || "No options found"}
  //           </li>
  //         )}
  //       </ul>
  //     )}
  //   </div>
  // );



// import React from "react";
// import { Select } from "@mui/material";
// // import MultiTextInput from "./MultiTextInput"; // Import the new component
// // import "./DynamicForm.css";
// import { IoMdTrash } from "react-icons/io";

// const MultiTextInput = ({
//     field,
//     formData,
//     onChange,
//     disabled,
//     useInputField = false,
//   }) => {
//     // Determine the key for formData and onChange
//     const key = !useInputField
//       ? field.ApiValue || field.label
//       : field.field || field.ApiValue || field.label;
  
//     const values = Array.isArray(formData[key]) ? formData[key] : [];
  
//     return (
//       <>
//         {values.map((val, idx) => (
//           <div
//             key={idx}
//             style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
//           >
//             <input
//               type="text"
//               className="minimal-input"
//               placeholder={`${field.label} ${idx + 1}`}
//               value={values[idx] || ""}
//               onChange={(e) => {
//                 const updated = [...values];
//                 updated[idx] = e.target.value;
//                 onChange(key, updated);
//               }}
//               disabled={disabled}
//               autoComplete="off"
//             />
//             {!disabled && idx > 0 && (
//               <button
//                 type="button"
//                 onClick={() => {
//                   const updated = [...values];
//                   updated.splice(idx, 1);
//                   onChange(key, updated);
//                 }}
//                 style={{
//                   marginLeft: "5px",
//                   background: "none",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//                 title="Remove"
//               >
//                 <IoMdTrash color="#dc3545" />
//               </button>
//             )}
//           </div>
//         ))}
//         {!disabled && (
//           <button
//             className="Add-Achievements"
//             type="button"
//             onClick={() => {
//               const updated = [...values, ""];
//               onChange(key, updated);
//             }}
//           >
//             + Add {field.label}
//           </button>
//         )}
//       </>
//     );
//   };

// const DynamicForm = ({
//   labels,
//   formData,
//   onChange,
//   onSubmit,
//   disabled,
//   submitDisabled,
//   formErrors,
//   useInputField = false,
// }) => {
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (onSubmit) {
//       onSubmit(formData);
//     }
//   };

//   return (
//     <form className="container minimal-form p-4" onSubmit={handleSubmit}>
//       <div className="row g-3">
//         {labels.map((field, i) => {
//           let inputElement = null;

//           if (field.isMulti && field.type === "text") {
//             // Use the MultiTextInput component here
//             inputElement = (
//               <MultiTextInput
//                 key={i}
//                 field={field}
//                 formData={formData}
//                 onChange={onChange}
//                 disabled={disabled}
//                 useInputField={useInputField}
//               />
//             );
//           } else if (field.type === "select") {
//             const key = !useInputField
//               ? field.ApiValue || field.label
//               : field.field || field.ApiValue || field.label;

//             const fieldValue = formData[key];

//             inputElement = (
//               <Select
//                 inputId={`input-${i}`}
//                 classNamePrefix="minimal-select"
//                 isDisabled={disabled}
//                 options={field.options}
//                 value={
//                   field.isMulti
//                     ? (fieldValue || []).map((val) => ({
//                         label: val.name || val.label,
//                         value: val,
//                       }))
//                     : fieldValue
//                     ? {
//                         label: fieldValue.name || fieldValue.label,
//                         value: fieldValue,
//                       }
//                     : null
//                 }
//                 onChange={(selectedOption) =>
//                   onChange(
//                     key,
//                     field.isMulti
//                       ? selectedOption
//                         ? selectedOption.map((opt) => opt.value)
//                         : []
//                       : selectedOption?.value || ""
//                   )
//                 }
//                 placeholder={`Select ${field.label}`}
//                 isClearable={!field.isMulti}
//                 isMulti={field.isMulti}
//               />
//             );
//           } else if (field.type === "textarea") {
//             const key = !useInputField
//               ? field.ApiValue || field.label
//               : field.field || field.ApiValue || field.label;

//             inputElement = (
//               <textarea
//                 id={`input-${i}`}
//                 className="textarea-input"
//                 placeholder={`Enter ${field.label}`}
//                 value={formData[key] || ""}
//                 onChange={(e) => onChange(key, e.target.value)}
//                 disabled={disabled}
//                 rows={4}
//               />
//             );
//           } else {
//             // Regular input field
//             const key = !useInputField
//               ? field.ApiValue || field.label
//               : field.field || field.ApiValue || field.label;

//             inputElement = (
//               <input
//                 type={field.type || "text"}
//                 id={`input-${i}`}
//                 className="minimal-input"
//                 placeholder={`Enter ${field.label}`}
//                 value={formData[key] || ""}
//                 onChange={(e) => onChange(key, e.target.value)}
//                 disabled={disabled}
//                 autoComplete="off"
//               />
//             );
//           }

//           const errorKey = !useInputField
//             ? field.ApiValue || field.label
//             : field.field || field.ApiValue || field.label;

//           return (
//             <div
//               key={i}
//               className={`col-12 ${
//                 field.type !== "textarea" ? "col-md-6 col-lg-4" : ""
//               }`}
//             >
//               <label className="minimal-label" htmlFor={`input-${i}`}>
//                 {field.label}{" "}
//                 {field.required && <span className="required-asterisk">*</span>}
//               </label>
//               {inputElement}
//               {formErrors[errorKey] && (
//                 <div className="form-error-text">{formErrors[errorKey]}</div>
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {onSubmit && (
//         <div className="d-flex justify-content-end mt-5">
//           <button
//             type="submit"
//             className="minimal-button"
//             disabled={submitDisabled}
//           >
//             Submit
//           </button>
//         </div>
//       )}
//     </form>
//   );
// };

// export default DynamicForm;


  